/*
 * Copyright (c) 2022 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import MockAdapter from 'axios-mock-adapter';
import { delayedResponse } from '../companies/companiesMock';
import { makeMockResponse } from '../mockUtils';
import {
    DeviceDetailsDto,
    DevicesListDto,
    RegistrationHistoryItemDto,
    FirmwareHistoryListDto,
    StatusHistoryListDto,
    OperatorHistoryListDto,
} from './devicesClient.typing';
import {
    registrationHistoryItemFactory,
    deviceDetailsFactory,
    deviceDtoFactory,
    firmwareHistoryItemFactory,
    operatorHistoryItemFactory,
    statusHistoryItemFactory,
} from './devicesFactories';

const DEVICES_LIST_URL = /\/1.0.0\/devices$/;
const DEVICE_DETAILS_URL = /\/devices\/\w+$/;
const FIRMWARE_HISTORY = /\/devices\/\w+\/firmwareVersionHistory/;
const STATUS_HISTORY = /\/devices\/\w+\/statusHistory/;
const OPERATOR_HISTORY = /\/devices\/\w+\/operatorHistory/;
const REGISTRATION_HISTORY = /\/devices\/\w+\/registrationHistory/;

export function addDevicesMockApi(mockAdapter: MockAdapter): void {
    mockAdapter.onPost(DEVICES_LIST_URL).reply((config) => {
        const body = JSON.parse(config.data);
        const data: DevicesListDto = {
            afterKeyFactoryNumber: '1431_re8932',
            devices: deviceDtoFactory.list({ count: body.limit }),
        };
        return delayedResponse(makeMockResponse(200, data, config), 300);
    });

    mockAdapter.onGet(DEVICE_DETAILS_URL).reply((config) => {
        const data: DeviceDetailsDto = deviceDetailsFactory.item();

        return delayedResponse(makeMockResponse(200, data, config), Math.random() * 200);
    });

    mockAdapter.onGet(FIRMWARE_HISTORY).reply((config) => {
        const data: FirmwareHistoryListDto = {
            count: config.params.limit * 3,
            items: firmwareHistoryItemFactory.list({ count: config.params.limit }),
        };

        return delayedResponse(makeMockResponse(200, data, config), 300);
    });

    mockAdapter.onGet(STATUS_HISTORY).reply((config) => {
        const data: StatusHistoryListDto = {
            count: config.params.limit * 3,
            items: statusHistoryItemFactory.list({ count: config.params.limit }),
        };

        return delayedResponse(makeMockResponse(200, data, config), 300);
    });

    mockAdapter.onGet(OPERATOR_HISTORY).reply((config) => {
        const data: OperatorHistoryListDto = {
            count: config.params.limit * 3,
            items: operatorHistoryItemFactory.list({ count: config.params.limit }),
        };

        return delayedResponse(makeMockResponse(200, data, config), 300);
    });

    mockAdapter.onGet(REGISTRATION_HISTORY).reply((config) => {
        const data: RegistrationHistoryItemDto[] = registrationHistoryItemFactory.list({ count: 5 });

        return delayedResponse(makeMockResponse(200, data, config), 300);
    });
}
